import { Box, withStyles } from '@material-ui/core';

export const ContentContainer = withStyles({
  root: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
})(Box);

export const HeaderContainer = withStyles(({ spacing }) => ({
  root: {
    paddingBottom: spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}))(Box);
